import { login } from './login';
import { addDataSource } from './addDataSource';
import { deleteDataSource } from './deleteDataSource';
import { addDashboard } from './addDashboard';
import { assertSuccessNotification } from './assertSuccessNotification';
import { deleteDashboard } from './deleteDashboard';
import { openDashboard } from './openDashboard';
import { saveNewDashboard } from './saveNewDashboard';
import { saveDashboard } from './saveDashboard';

export const Flows = {
  login,
  addDataSource,
  deleteDataSource,
  addDashboard,
  assertSuccessNotification,
  deleteDashboard,
  openDashboard,
  saveNewDashboard,
  saveDashboard,
};
